(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ms-home"] && !Shopify.designMode) return;
  try {
    
  function initBenefitRolls(root) {
    if (!('IntersectionObserver' in window)) return;
    var motion = window.matchMedia('(max-width: 599px) and (prefers-reduced-motion: no-preference)');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || !motion.matches) return;
        entry.target.classList.add('bfk-benefit--rolling');
        observer.unobserve(entry.target);
      });
    }, {threshold:0.35});
    root.querySelectorAll('.bfk-benefit-card').forEach(function(card,index) {
      if(card.dataset.rollReady) return;
      card.dataset.rollReady='true';
      card.style.setProperty('--bfk-roll-delay', (index % 3)*120+'ms');
      observer.observe(card);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initBenefitRolls(document);}); else initBenefitRolls(document);
  document.addEventListener('shopify:section:load',function(e){initBenefitRolls(e.target);});

  function initBookGalleries(root) {
    root.querySelectorAll('.bfk-card-gallery').forEach(function(gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var startX=0, startY=0, dragged=false;
      gallery.addEventListener('pointerdown',function(e){startX=e.clientX;startY=e.clientY;dragged=false;});
      gallery.addEventListener('pointermove',function(e){if(Math.abs(e.clientX-startX)>8 || Math.abs(e.clientY-startY)>8) dragged=true;});
      gallery.addEventListener('click',function(e){if(dragged){e.preventDefault();e.stopPropagation();}});
      gallery.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();gallery.scrollBy({left:gallery.clientWidth*(e.key==='ArrowRight'?1:-1),behavior:'smooth'});}});
      gallery.addEventListener('scroll',function(){
        var dots=gallery.nextElementSibling;
        if(!dots || !dots.classList.contains('bfk-card-gallery-dots')) return;
        var index=Math.round(gallery.scrollLeft/gallery.clientWidth);
        Array.from(dots.children).forEach(function(dot,i){dot.classList.toggle('active',i===index);});
      },{passive:true});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initBookGalleries(document);}); else initBookGalleries(document);
  document.addEventListener('shopify:section:load',function(e){initBookGalleries(e.target);});

  function initialiseBfkSliders(root) {
    root.querySelectorAll('.bfk-adventures').forEach(function (slider) {
      if (slider.dataset.bfkSliderReady === 'true') return;

      var track = slider.querySelector('[data-bfk-slider-track]');
      var cards = Array.from(track ? track.querySelectorAll('.bfk-book-card') : []);
      var dots = Array.from(slider.querySelectorAll('[data-bfk-slide]'));
      if (!track || !cards.length || !dots.length) return;

      slider.dataset.bfkSliderReady = 'true';
      var frame;

      function setActiveDot() {
        var trackCentre = track.scrollLeft + (track.clientWidth / 2);
        var closestIndex = 0;
        var closestDistance = Infinity;

        cards.forEach(function (card, index) {
          var cardCentre = card.offsetLeft + (card.offsetWidth / 2);
          var distance = Math.abs(cardCentre - trackCentre);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        dots.forEach(function (dot, index) {
          if (index === closestIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });

      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(setActiveDot);
      }, { passive: true });
      window.addEventListener('resize', setActiveDot);
      setActiveDot();
    });
  }

  initialiseBfkSliders(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialiseBfkSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
